export const PrescriptionType = {
    NEW: 'NEW',
    DELIVERED: 'DELIVERED',
    EXPIRED: 'EXPIRED',
 };